<script setup>

import Button from "primevue/button";
import ConfirmPopup from "primevue/confirmpopup";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {ref, defineEmits, defineProps, watch} from "vue";
import {useConfirm} from "primevue/useconfirm";
import {useUpkeep} from "../../logic/UpkeepCRUD.js";
import { trans } from 'laravel-vue-i18n';
const deletePopup = ref(false);
const confirm = useConfirm();
const transformedColumns = ref();
const props = defineProps({
  data: Array,
  columns: Array,
  model: String
})
const emit = defineEmits(['needs-update']);
const confirmDelete = (id, event) => {
  confirm.require({
    target: event.currentTarget,
    message: trans('common.confirm_delete'),
    header: trans('common.deletion'),
    icon: 'pi pi-info-circle',
    rejectClass: 'p-button-secondary p-button-outlined p-button-sm',
    acceptClass: 'p-button-danger p-button-sm',
    rejectLabel: trans('common.cancel'),
    acceptLabel: trans('common.delete'),
    accept: () => {
      loading.value = true;
      useUpkeep().deleteRecord(id, props.model).then((result) => {
        if(result) {
          emit('needs-update', result.data)
        }
        loading.value = false;
      })
    },
    onShow: () => {
      deletePopup.value = true;
    },
    onHide: () => {
      deletePopup.value = false;
    }
  });
}

const loadColumns = (cols) => {
  transformedColumns.value = cols.map((el) => el.children)[0]
  transformedColumns.value?.forEach((q, index) => {
    if(q.hideOn && q.hideOn.includes(route.meta.type))
      transformedColumns.value.splice(index, 1);
  })
}

watch(props.columns, (val) => {
  loadColumns(val)
}, {immediate: true})
const loading = ref(false);
</script>

<template>
  <DataTable stripedRows :value="data" class="w-100">
    <template v-for="(column, columnIndex) in transformedColumns" :key="columnIndex">
      <Column v-if="column.type==='text'" :sortable="column.sortable" :field="column.id" :header="column.label">

      </Column>
      <Column v-if="column.type==='number'" :sortable="column.sortable" :field="column.id" :header="column.label">

      </Column>
      <Column v-if="column.type==='price'" :sortable="column.sortable" :field="column.id" :header="column.label">
        <template #body="slotProps">
          {{ Intl.NumberFormat('cs-CZ', {
          style: 'currency',
          currency: slotProps.data[column.currency_column] ?? 'XXX',
        }).format(slotProps.data[column.id]) }}
        </template>
      </Column>
      <Column v-if="column.type==='password'" :sortable="column.sortable" :field="column.id" :header="column.label">

      </Column>
      <Column v-if="column.type==='select'" :sortable="column.sortable" :field="column.id" :header="column.label">
        <template #body="slotProps">
          {{ column.children?.find((el) => el.value === slotProps.data[column.id])?.label}}
        </template>
      </Column>
      <Column v-if="column.type==='switch'" :sortable="column.sortable" :field="column.id" :header="column.label">
        <template #body="slotProps">
          {{ column.children?.find((el) => el.value === slotProps.data[column.id])?.label}}
        </template>
      </Column>
    </template>

    <Column>
      <template #body="slotProps">
        <Button icon="pi pi-pencil" severity="secondary" text
                @click="router.visit({ path: '/upkeep/' + model + '/' + slotProps.data.id })"/>
        <Button icon="pi pi-trash" severity="danger" text @click="confirmDelete(slotProps.data.id, $event)" :aria-expanded="deletePopup" :aria-controls="deletePopup ? 'confirm' : null"/>
      </template>
    </Column>
  </DataTable>
  <ConfirmPopup v-model="deletePopup"></ConfirmPopup>
</template>

<style scoped lang="scss">

</style>
